<template>
    <vs-input 
        type="number" 
        v-model="rate" 
        step="0.1" 
        placeholder="0.00"
        @input="onInput"
    />
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
    data() {
        return {
            rate: ""
        }
    },
    methods: {
        onInput(newVal) {
            this.params.handleFilter({
                rate: newVal
            })
        }
    },
    mounted() {
        const values = this.params.getValues()
        if (values.rate !== null && values.rate !== undefined) {
            this.rate = values.rate
        }
    }
})
</script>